import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/layout/Layout';
const Home = lazy(() => import('./pages/Home'));
const FdmServices = lazy(() => import('./pages/FdmServices'));
const SlaServices = lazy(() => import('./pages/SlaServices'));
const CadServices = lazy(() => import('./pages/CadServices'));
const Contact = lazy(() => import('./pages/Contact'));
const Calculator = lazy(() => import('./pages/Calculator'));
const OrderPage = lazy(() => import('./pages/OrderPage'));
const OrderConfirm = lazy(() => import('./pages/OrderConfirm'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogDetail = lazy(() => import('./pages/BlogDetail'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const Community = lazy(() => import('./pages/Community'));
const Privacy = lazy(() => import('./pages/Privacy'));
const VerifyEmailPage = lazy(() => import('./pages/VerifyEmailPage'));
const RegisterPage = lazy(() => import('./pages/Register'));
const AuditLogPage = lazy(() => import('./pages/admin/AuditLogPage'));
const LoginPage = lazy(() => import('./pages/admin/LoginPage'));
const DashboardPage = lazy(() => import('./pages/admin/DashboardPage'));
const UsersPage = lazy(() => import('./pages/admin/UsersPage'));
const AdminProfilePage = lazy(() => import('./pages/admin/AdminProfilePage'));
const BlogPublishPage = lazy(() => import('./pages/admin/BlogPublishPage'));
const BlogManagePage = lazy(() => import('./pages/admin/BlogManagePage'));
const ArticlesPage = lazy(() => import('./pages/admin/blog/ArticlesPage'));
const ArticleEditorPage = lazy(() => import('./pages/admin/blog/ArticleEditorPage'));
const CategoriesPage = lazy(() => import('./pages/admin/blog/CategoriesPage'));
const TagsPage = lazy(() => import('./pages/admin/blog/TagsPage'));
const ArticlesCreatePage = lazy(() => import('./pages/admin/blog/ArticlesCreatePage'));
const ArticlesDraftsPage = lazy(() => import('./pages/admin/blog/ArticlesDraftsPage'));
const ArticlesScheduledPage = lazy(() => import('./pages/admin/blog/ArticlesScheduledPage'));
const ArticlesArchivedPage = lazy(() => import('./pages/admin/blog/ArticlesArchivedPage'));
const MediaPage = lazy(() => import('./pages/admin/blog/MediaPage'));
const CommentsPage = lazy(() => import('./pages/admin/blog/CommentsPage'));
const CalendarPage = lazy(() => import('./pages/admin/blog/CalendarPage'));
const AnalyticsPage = lazy(() => import('./pages/admin/blog/AnalyticsPage'));
const SettingsPage = lazy(() => import('./pages/admin/blog/SettingsPage'));
const ImportPage = lazy(() => import('./pages/admin/blog/ImportPage'));
const ExportPage = lazy(() => import('./pages/admin/blog/ExportPage'));
const ImportExportPage = lazy(() => import('./pages/admin/blog/ImportExportPage'));
import ProtectedRoute from './components/admin/ProtectedRoute';
import NotImplementedPage from './pages/admin/NotImplementedPage';
import OrdersPage from './pages/admin/OrdersPage';
import { AuthProvider } from './api/auth/AuthContext';
import { PermissionProvider } from './api/permissions/PermissionContext';
import { CartProvider } from './contexts/CartContext';
import './i18n';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <PermissionProvider>
        <CartProvider>
        <Router>
          <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            {/* Rutas públicas con Layout común */}
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="servicios/impresion-fdm" element={<FdmServices />} />
              <Route path="servicios/impresion-sla" element={<SlaServices />} />
              <Route path="servicios/diseno-cad" element={<CadServices />} />
              <Route path="calculadora" element={<Calculator />} />
              <Route path="orden" element={<OrderPage />} />
              <Route path="orden/confirmar/:token" element={<OrderConfirm />} />
              <Route path="contacto" element={<Contact />} />
              <Route path="portafolio" element={<Portfolio />} />
              <Route path="comunidad" element={<Community />} />
              <Route path="privacidad" element={<Privacy />} />
              <Route path="register" element={<RegisterPage />} />
              <Route path="verify-email" element={<VerifyEmailPage />} />
              <Route path="blog" element={<Blog />} />
              <Route path="blog/:slug" element={<BlogDetail />} />
            </Route>
            
            {/* Rutas de administración */}
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/admin" element={<ProtectedRoute />}>
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="profile" element={<AdminProfilePage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="audit" element={<AuditLogPage />} />
              <Route path="blog/publish" element={<BlogPublishPage />} />
              <Route path="blog/manage" element={<BlogManagePage />} />
              <Route path="not-implemented" element={<NotImplementedPage />} />
              <Route path="blog/articles" element={<ArticlesPage />} />
              <Route path="blog/articles/:id/edit" element={<ArticleEditorPage />} />
              <Route path="blog/categories" element={<CategoriesPage />} />
              <Route path="blog/tags" element={<TagsPage />} />
              <Route path="blog/articles/create" element={<ArticlesCreatePage />} />
              <Route path="blog/articles/drafts" element={<ArticlesDraftsPage />} />
              <Route path="blog/articles/scheduled" element={<ArticlesScheduledPage />} />
              <Route path="blog/articles/archived" element={<ArticlesArchivedPage />} />
              <Route path="blog/media" element={<MediaPage />} />
              <Route path="blog/comments" element={<CommentsPage />} />
              <Route path="blog/calendar" element={<CalendarPage />} />
              <Route path="blog/analytics" element={<AnalyticsPage />} />
              <Route path="blog/settings" element={<SettingsPage />} />
              <Route path="blog/import" element={<ImportPage />} />
              <Route path="blog/export" element={<ExportPage />} />
              <Route path="blog/import-export" element={<ImportExportPage />} />
              {/* Aquí se pueden agregar más rutas protegidas */}
              <Route path="orders" element={<OrdersPage />} />
            </Route>
          </Routes>
          </Suspense>
        </Router>
        </CartProvider>
        </PermissionProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
